import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import { FaWhatsapp } from 'react-icons/fa';

// 🔥 AUTO VERSION FROM package.json
const APP_VERSION = process.env.REACT_APP_VERSION || "0.0.0";

// 🔥 FORCE RELOAD WHEN VERSION CHANGES
const savedVersion = localStorage.getItem("app_version");
if (savedVersion !== APP_VERSION) {
  localStorage.setItem("app_version", APP_VERSION);
  window.location.reload(true);
}

// 🔥 REMOVE ANY OLD SERVICE WORKERS
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
